import { render } from "./FileUploadComponent.vue?vue&type=template&id=bd9d3d34&scoped=true"
import script from "./FileUploadComponent.vue?vue&type=script&lang=js"
export * from "./FileUploadComponent.vue?vue&type=script&lang=js"

import "./FileUploadComponent.vue?vue&type=style&index=0&id=bd9d3d34&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd9d3d34"]])

export default __exports__